// One place to render a season as a human label. A league can now run several
// seasons in the same calendar year (#157), so a bare year is ambiguous and a
// bare name can be blank — always combine them. The backend guarantees
// same-year seasons have distinct names, so `year · name` is unique.
//
// Examples: {2026, "Summer S2"} → "2026 · Summer S2"; {2026, null} → "2026 Season".
export function formatSeasonLabel(season: {
  year: number | string
  name?: string | null
}): string {
  const name = season.name?.trim()
  return name ? `${season.year} · ${name}` : `${season.year} Season`
}

// "{name} {year}" for headers that pair a season/tournament name with its
// year — but skip the year when the name already carries it, so a season
// named "Fall 2026" renders as "Fall 2026", not "Fall 2026 2026" (#199).
export function nameWithYear(name: string, year?: number | string | null): string {
  return nameIncludesYear(name, year) || year === null || year === undefined || year === ''
    ? name
    : `${name} ${year}`
}

export function nameIncludesYear(name: string, year: number | string | null | undefined): boolean {
  if (year === null || year === undefined || year === '') return false
  return new RegExp(`(^|\\D)${String(year)}(\\D|$)`).test(name)
}
